import { useTranslation } from "react-i18next";

const TruckCard = ({ truck }) => {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-2xl shadow-mainShadow">
      <img className="h-[300px] w-full object-fill" src={truck.img} alt={truck.name} />
      <div className="p-5 space-y-4">
        <h2 className="text-2xl font-bold text-mainRed">{truck.name}</h2>
        {!truck.liquid && !truck.car ? (
          <>
            <p className="flex items-center justify-between">
              <span className="font-medium text-mainGray">{t("length-")}</span>
              <span>{truck.length}</span>
            </p>
            <p className="flex items-center justify-between">
              <span className="font-medium text-mainGray">{t("width-")}</span>
              <span>{truck.width}</span>
            </p>

            <p className="flex items-center justify-between">
              <span className="font-medium text-mainGray">{t("height-")}</span>
              <span>{truck.height}</span>
            </p>
          </>
        ) : null}
        {truck.liquid ? (
          <p className="flex items-center justify-between">
            <span className="font-medium text-mainGray">{t("capacity-")}</span>
            <span>{truck.capacity}</span>
          </p>
        ) : null}
        {truck.car ? (
          <p className="flex items-center justify-between">
            <span className="font-medium text-mainGray">{t("numberOFCars")}</span>
            <span>{truck.number}</span>
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default TruckCard;
